


















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import {Location} from "vue-router"

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsNavigatorBackLink extends Vue {
    /**
     * Where to navigate to on click.
     * @required
     */
    @Prop() to!: Location;

    @Ref() linkEl!: HTMLElement;
    hover = false;

    startAnimation () {
        this.linkEl.classList.add('animate');
        this.hover = true;
    }

    animationTicker() {
        if (!this.hover) {
            this.linkEl.classList.remove('animate');
        }
    }

}
